import PropTypes from 'prop-types';

export const LEOMailingAddressFields = {
  address: PropTypes.string,
  address2: PropTypes.string,
  address3: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipcode: PropTypes.string,
};

export const LEOAddress = PropTypes.shape({
  ...LEOMailingAddressFields,
  website: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  fax: PropTypes.string,
  is_physical: PropTypes.bool,
  is_regular_mail: PropTypes.bool,
  process_domestic_registrations: PropTypes.bool,
  process_absentee_requests: PropTypes.bool,
  process_absentee_ballots: PropTypes.bool,
  process_overseas_requests: PropTypes.bool,
  process_overseas_ballots: PropTypes.bool,
});

export const LEOAddresses = PropTypes.arrayOf(LEOAddress);
